// removed by extract-text-webpack-plugin
module.exports = {"container":"_2WdjXSyxR_CVZJndejV1Vk","routes":"OCw1wCUUXMK75fm6zX19T"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/SSAnnexedCTO/styles.css
// module id = 3287
// module chunks = 0